<template lang="pug">
  .page-games.page-mobile
    h1.hiddenH1(v-if="$i18n.locale === 'ru'") турниры по Brawl Stars, Free fire, PUBG Mobile, шахматы.
    h1.hiddenH1(v-else) {{ $t('games') }}

    template(v-if="isA")
      p.page-games__title {{ $t('games') }}

      GamesList(:with-title="false" :is-separated="hasLinkedGames" :games="hasLinkedGames ? separatedList : list")
    template(v-else)
      h1.page-games__title {{ title }}

      template(v-if="step === 'initial'")
        .page-games__variants
          .page-games__variant
            p.page-games__variant-text {{ $tB('wantToPlayFree') }}
            Button.page-games__variant-button(is-primary @click="setStep('free')")
              | {{ $tB('playFree') }}
              img(:src="require('~/assets/img/icons/arrow-right.svg')" alt="arrow right")
          .page-games__variant
            p.page-games__variant-text {{ $tB('wantToPlayPaid') }}
            Button.page-games__variant-button(is-primary @click="setStep('paid')")
              | {{ $tB('playPaid') }}
              img(:src="require('~/assets/img/icons/arrow-right.svg')" alt="arrow right")

      template(v-if="step === 'free'")
        .page-games__info
          img.page-games__info-icon(:src="require('~/assets/img/icons/info.svg')" width="16" height="16" alt="info")
          span.page-games__info-text(v-html="$tB('doMissions')")
        ProfileTabs(:items="tabs" :active-tab-index="currentTabIndex" @change="onTabChange")
        .page-games__tournaments(v-if="tournaments")
          .page-games__tournaments-list(:style="{'grid-template-columns': `repeat(${tournaments.length}, 315px)`}")
            .page-games__tournament(v-for="tournament in tournaments" :key="tournament.id")
              TournamentCardWithCover(:tournament="tournament")

      template(v-if="step === 'paid'")
        ProfileTabs(:items="tabs" :active-tab-index="currentTabIndex" @change="onTabChange")
        .page-games__tournaments(v-if="tournaments && tournaments.length")
          .page-games__tournaments-list(:style="{'grid-template-columns': `repeat(${tournaments.length}, 315px)`}")
            .page-games__tournament(v-for="tournament in tournaments" :key="tournament.id")
              TournamentCardWithCover(:tournament="tournament")
    PageArticle(v-if="article" :content="article")
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import TournamentsService from '~/services/TournamentsService'
import GamesList from '~/components/GamesList/GamesList'
import ProfileTabs from '~/components/ProfileTabs/ProfileTabs'
import TournamentCardWithCover from '~/components/TournamentCard/TournamentCardWithCover'
import { createMeta } from '~/utils/meta'
import PageArticle from '~/components/MarketplaceComponents/PageArticle'

export default {
  name: 'PageGames',

  components: {
    PageArticle,
    GamesList,
    ProfileTabs,
    TournamentCardWithCover
  },

  data () {
    return {
      step: 'initial',
      currentTabIndex: 0,
      currentGameName: null,
      tournaments: undefined
    }
  },

  computed: {
    ...mapState('games', ['games', 'gamesByName']),
    ...mapGetters('user', ['gameAccount']),

    hasLinkedGames () {
      return !!this.separatedList[0]?.length
    },

    article () {
      if (this.$i18n.locale === 'ru') {
        return '<h2>Турниры по мобильным играм на деньги | Играй и зарабатывай</h2>     <h3>Введение</h3>     <p>Мир мобильных игр стремительно развивается, и все больше игроков ищут способы не только наслаждаться играми, но и зарабатывать на этом деньги. Маркетплейс цифровых товаров <strong>ru.gaming-goods.com</strong> предлагает уникальную возможность участвовать в турнирах по популярным мобильным играм и выигрывать ценную валюту, которую можно потратить на платформе. В этой статье мы расскажем, как участвовать в турнирах, какие игры наиболее популярны среди участников и какие преимущества дает участие в турнирах на ru.gaming-goods.com.</p>          <h3>Популярные игры для турниров</h3>     <p>На ru.gaming-goods.com проводятся турниры по различным популярным мобильным играм, что позволяет каждому найти игру по душе. Рассмотрим подробнее некоторые из них.</p>          <h4>Шахматы</h4>     <p>Шахматы — это классическая стратегическая игра, которая требует от игроков высокого уровня мышления и тактического планирования. На ru.gaming-goods.com регулярно проводятся турниры по шахматам, в которых могут участвовать как новички, так и опытные шахматисты. Играйте в шахматы, участвуйте в турнирах и зарабатывайте деньги.</p>          <h4>PUBG Mobile</h4>     <p>PUBG Mobile — одна из самых популярных мобильных игр в жанре королевской битвы. Игра привлекает миллионы игроков по всему миру благодаря захватывающему геймплею и высокому уровню соревновательности. На ru.gaming-goods.com вы можете участвовать в турнирах по PUBG Mobile, где победители получают ценную валюту и призы.</p>          <h4>Free Fire</h4>     <p>Free Fire — еще одна популярная игра в жанре королевской битвы, которая славится своими быстрыми матчами и разнообразием персонажей. Участвуйте в турнирах по Free Fire на ru.gaming-goods.com и зарабатывайте реальные деньги, демонстрируя свои навыки в этой захватывающей игре.</p>          <h4>Brawl Stars</h4>     <p>Brawl Stars — динамичная и увлекательная игра от компании Supercell, которая предлагает разнообразие режимов и персонажей. Турниры по Brawl Stars на ru.gaming-goods.com позволяют игрокам соревноваться за ценные призы и показывать свои лучшие результаты в этой популярной игре.</p>          <h4>Fortnite</h4>     <p>Fortnite — культовая игра в жанре королевской битвы, известная своими уникальными строительно-боевыми механиками. Участвуйте в турнирах по Fortnite на ru.gaming-goods.com и выигрывайте валюту, которую можно потратить на платформе. Играйте в соло, в команде или в паре и докажите, что вы лучший игрок.</p>          <h4>Clash Royale</h4>     <p>Clash Royale — популярная мобильная игра в жанре стратегии в реальном времени, где игроки соревнуются друг с другом, используя уникальные колоды карт. Турниры по Clash Royale на ru.gaming-goods.com предоставляют отличную возможность проверить свои навыки и заработать ценные призы.</p>          <h3>Как участвовать в турнирах</h3>     <p>Участие в турнирах на ru.gaming-goods.com очень простое и доступное для всех. Вот основные шаги:</p>     <ol>         <li><strong>Зарегистрируйтесь</strong> на сайте ru.gaming-goods.com.</li>         <li><strong>Выберите турнир</strong> по одной из доступных игр.</li>         <li><strong>Запишитесь</strong> на участие и оплатите входной билет (если требуется).</li>         <li><strong>Играйте</strong> и побеждайте в турнире.</li>         <li><strong>Получите призы</strong> в виде игровой валюты или других ценных предметов.</li>     </ol>          <h3>Преимущества участия</h3>     <p>Участие в турнирах на ru.gaming-goods.com имеет множество преимуществ:</p>     <ul>         <li><strong>Ежедневные и еженедельные турниры</strong> — Возможность участвовать в соревнованиях каждый день.</li>         <li><strong>Разнообразие игр</strong> — От классических до современных мобильных игр.</li>         <li><strong>Реальные призы</strong> — Выигрывайте валюту и тратьте её на платформе.</li>         <li><strong>Для всех уровней</strong> — Турниры для новичков и профессионалов.</li>         <li><strong>Бесплатный вход</strong> — Участие в некоторых турнирах возможно без платы за вход.</li>     </ul>          <h3>Использование призов</h3>     <p>Выигранные призы можно потратить на платформе ru.gaming-goods.com. Покупайте цифровые товары, игровые валюты (гемы, алмазы, UC и другие), скины и многое другое. Наша платформа предлагает широкий выбор товаров для различных игр, что делает её идеальным местом для всех геймеров.</p>          <h3>Безопасность и надежность</h3>     <p>Наш маркетплейс гарантирует безопасность и надежность транзакций. Мы сотрудничаем только с проверенными продавцами, предоставляем гарантию на товары и обеспечиваем мгновенную автоматическую выдачу покупок. Ваши данные и средства находятся в полной безопасности.</p>          <h3>Заключение</h3>     <p>Присоединяйтесь к ru.gaming-goods.com, участвуйте в турнирах по мобильным играм и зарабатывайте, играя в любимые игры. Это отличный способ совместить приятное с полезным — наслаждаться играми и получать за это реальные деньги и ценные призы. Не упустите возможность стать частью нашего игрового сообщества и начать зарабатывать уже сегодня!</p>          <h3>Зарегистрируйтесь сейчас</h3>     <p><strong>Зарегистрируйтесь</strong> на ru.gaming-goods.com, выберите свой первый турнир и начинайте выигрывать!</p>'
      }

      return undefined
    },

    tabs () {
      return Object.entries(this.gamesByName)
        .filter(([_, game]) => game.is_enabled)
        .map(([gameName, game]) => {
          return {
            title: game.extra_data.title,
            id: gameName,
            icon: game.extra_data.icon,
            number: game.id
          }
        })
        .sort((a, b) => {
          const byLinking = !!this.gameAccount(b.id) - !!this.gameAccount(a.id)
          const byGameNumber = a.number - b.number

          return byLinking || byGameNumber
        })
    },

    list () {
      // eslint-disable-next-line camelcase
      return this.games.filter(({ is_enabled }) => is_enabled)
    },

    separatedList () {
      return [
        this.list.filter(game => this.gameAccount?.(game?.name)),
        this.list.filter(game => !this.gameAccount?.(game?.name))
      ]
    },

    isA () {
      return true

      // if (!this.user) {
      //   return true
      // }
      //
      // return this.user.id <= 774000 || this.user.id % 10 !== 0
    },

    title () {
      switch (this.step) {
        case 'initial':
          return this.$tB('title')
        case 'free':
          return this.$tB('titleFreerolls')
        case 'paid':
          return this.$tB('titlePaid')
        default:
          return this.$t('games')
      }
    }
  },

  methods: {
    $tB (key) {
      return this.$t(`playPageVariantB__${key}`)
    },

    setStep (step) {
      this.step = step
      this.onTabChange({
        index: 0,
        item: this.tabs?.[0]
      })
    },

    async loadTournaments () {
      this.tournaments = undefined

      console.log(this.currentGameName)

      switch (this.step) {
        case 'free':
          this.tournaments = (await TournamentsService.findFreerolls(this.$axios, this.currentGameName)).data?.data
          break
        case 'paid':
          this.tournaments = (await TournamentsService.findCommercialTournaments(this.$axios, this.currentGameName)).data?.data
          break
      }
    },

    onTabChange ({ index, item }) {
      console.log('item:', item)
      this.currentTabIndex = index
      this.currentGameName = item?.id

      this.loadTournaments()
    }
  },

  head () {
    if (this.$i18n.locale === 'ru') {
      return createMeta.call(this, {
        title: 'Турниры по мобильным играм на деньги | Играй и зарабатывай',
        description: 'Принимай участие в ежедневных турнирах по Brawl Stars, Free fire, PUBG Mobile, шахматы.Выигрывай и получай реальные деньги. Призовые фонды. Соревнование по мобильным играм.',
        sharingTitle: 'Турниры по мобильным играм на деньги | Играй и зарабатывай',
        sharingDescription: 'Принимай участие в ежедневных турнирах по Brawl Stars, Free fire, PUBG Mobile, шахматы.Выигрывай и получай реальные деньги. Призовые фонды. Соревнование по мобильным играм.',
        keywords: 'тетрис,crazy chicks,jump ball,Dont drop the white ball,игры на деньги,бс,мобильная игра,приложения,заработать,получить деньги,tentrix,гемы,gems,алмазы,uc,santa,мини игры,флеш игры,flash,Шахматы,Пабг мобайл,Фри файер,Бравл старс,Фортнайт,Клеш рояль,fortnite,free fire,Clash Royale,Видеоигра,смартфон,игра,андроид,айфон,ios,android,браво,турниры,на деньги,личес,lichess,соревнования,для новичков,профессионалов,бесплатный вход,свободный,для всех,приглашай,ежедневные,ежеденельные,каждый день,свободный,Турниры,турнир,соревнование,реальные,заработай,получай,выиграть,новички,заядлые,опытные,подписка,покупай,играй,призовой фонд,бесплатно,вход,билет,профит,прибыль,хорошо играешь,ежедневные обновления,сайт,для всех,играй и зарабатывай,тратить,рубли,евро,большой,турнирная сетка,первый,по киллам,килл,участвовать,играть,призовые,соло,команда,пара,фонд,сетка,приз,вход,зарегистрироваться,тг,правила,рега,расписание,ближайшие сегодня,сайт,онлайн,бесплатный'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.hiddenH1 {
  display: none;
}

.page-games {
  color: $white;

  &__title {
    margin-bottom: 28px;
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;

    @media (min-width: $breakpointDesktopWide) {
      margin-bottom: 40px;
      font-size: 48px;
      font-weight: 700;
      line-height: 52px;
    }
  }

  &__variants {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 16px;

    @media (min-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
      grid-gap: 20px;
    }

    @media (min-width: $breakpointDesktopWide) {
      grid-gap: 24px;
    }
  }

  &__variant {
    border-radius: 16px;
    background: linear-gradient(262deg, rgba(49, 27, 146, 0.80) 5.62%, rgba(94, 53, 177, 0.80) 95.25%);
    padding: 20px;

    @media (min-width: $breakpointDesktopWide) {
      padding: 24px 36px;
    }

    &:last-child {
      background: linear-gradient(262deg, rgba(74, 20, 140, 0.80) 5.62%, rgba(142, 36, 170, 0.80) 95.25%);
    }

    &-text {
      color: $white;
      font-size: 22px;
      font-weight: 700;
      line-height: 28px;
      margin: 0 0 16px;
    }

    &-button {
      width: 100%;

      @media (min-width: $breakpointDesktopWide) {
        width: 296px;
      }
    }
  }

  &__info {
    display: grid;
    grid-template-columns: 16px 1fr;
    grid-gap: 8px;
    align-items: start;
    margin: 20px 0;

    &-icon {
      width: 16px;
      height: 16px;

      ::v-deep g {
        fill: $red60;
      }
    }

    &-text {
      color: $white;
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  &__tournaments {
    margin-top: 22px;
    width: 100%;
    overflow-x: hidden;

    &-list {
      @include scroll;
      overflow-x: auto;
      display: grid;
      grid-template-columns: repeat(4, 315px);
      grid-gap: 8px;
      padding-bottom: 20px;

      @media (min-width: $breakpointDesktopWide) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }
}
</style>
